import { Component } from "@angular/core";

@Component({
	selector: "sdi-homepage-contact-us",
	templateUrl: "./homepage-contact-us.component.html",
	styleUrls: ["./homepage-contact-us.component.scss"]
})
export class HomepageContactUsComponent {}
